<template>

	<div class="user_wbox" style="padding-top: 20px;margin-top: 0;">
		<el-container>
			<div class="inter">

				<div class="sjz_goods_detail_container" v-if="info.archives">
					<div class="sjz_goods_info">
						<div class="sjz_goods_title">
							{{ info.archives.title }}</div>
						<div class="sjz_account_info">
							<div class="info_row">
								<div class="info_item">
									<div class="info_label">{{ info.archives.login_type_text }}</div>
									<div class="info_value">登录方式</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.qufu_text }}</div>
									<div class="info_value">游戏区服</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.duanwei_text }}</div>
									<div class="info_value">段位</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.zichan }}</div>
									<div class="info_value">总资产(m)</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.chunbi }}</div>
									<div class="info_value">纯币资产(m)</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.level }}</div>
									<div class="info_value">账号等级</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.kd }}</div>
									<div class="info_value">KD</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.xunlian }}级</div>
									<div class="info_value">训练中心</div>
								</div>
								<div class="info_item" style="padding: 12px 0px;">
									<div class="info_label">{{ info.archives.box_text }}</div>
									<div class="info_value">安全箱</div>
								</div>
								<div class="info_item">
									<div class="info_label"> {{ info.archives.bachang }}级</div>
									<div class="info_value">靶场等级</div>
								</div>
							</div>
							<div class="info_row">
								<div class="info_item">
									<div class="info_label">{{ info.archives.zuqi }}</div>
									<div class="info_value">租期</div>
								</div>
								<div class="info_item" v-if="info.archives.awm > 0">
									<div class="info_label">{{ info.archives.awm }}<span v-if="info.archives.awm_type === '0'" style="color:#e4393c;margin-left:4px;">(赠送)</span></div>
									<div class="info_value">awm子弹</div>
								</div>
								<div class="info_item" v-if="info.archives.liutao_helm > 0">
									<div class="info_label">{{ info.archives.liutao_helm }}<span v-if="info.archives.liutao_helm_type === '0'" style="color:#e4393c;margin-left:4px;">(赠送)</span></div>
									<div class="info_value">六套头盔</div>
								</div>
								<div class="info_item" v-if="info.archives.liutao_armor > 0">
									<div class="info_label">{{ info.archives.liutao_armor }}<span v-if="info.archives.liutao_armor_type === '0'" style="color:#e4393c;margin-left:4px;">(赠送)</span></div>
									<div class="info_value">六套盔甲</div>
								</div>
								<div class="info_item" v-if="info.archives.barrett > 0">
									<div class="info_label">{{ info.archives.barrett }}<span v-if="info.archives.barrett_type === '0'" style="color:#e4393c;margin-left:4px;">(赠送)</span></div>
									<div class="info_value">巴雷特子弹</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.is_feng_text }}</div>
									<div class="info_value">封禁记录</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.is_ben_text }}</div>
									<div class="info_value">人脸是否本人</div>
								</div>
								<div class="info_item">
									<div class="info_label">{{ info.archives.changzhu_text }}</div>
									<div class="info_value">常用登录地</div>
								</div>
								<div class="info_item">
									<div class="info_label"> {{ info.archives.leixing_text }}</div>
									<div class="info_value">账号类型</div>
								</div>
								<div class="info_item special">
									<div class="special_content">
										<div class="special_item"><span class="special_label">持有刀皮</span>

											<span class="special_value tooltip-text" data-tooltip="">{{
												info.archives.daopi_text }}</span>
										</div>
										<div class="special_item"><span class="special_label">干员外观</span><span
												class="special_value tooltip-text" data-tooltip="">{{
													info.archives.ganyuan_text }}</span></div>
									</div>
								</div>
							</div>
						</div>
						<div class="ant-row" style="margin-bottom: 22px;">
							<div class="" style="text-align: right;"><span class="msg-series-large">比例 <span
										class="msg-series-text">{{ info.archives.bili }}</span></span><span
									class="msg-series-large">价格<span class="msg-series-price">{{ info.archives.price
									}}<span class="msg-series-unit">元</span></span></span><span
									class="msg-series-large last-item">押金<span class="msg-series-value">{{ info.archives.yajin }}<span
											class="msg-series-unit">元</span></span></span></div>
						</div>
						<div class="ant-row ant-row2" style="padding: 16px 20px;">
							<div class="ant-col-6">
								<div style="display: flex;">
									<div class="goods-code-box">
										<p>商品编号</p>
										<p style="color: rgb(51, 51, 51); cursor: pointer;">{{ info.archives.id }}<i
												class="icon-copy-div"></i></p>
									</div>
								</div>
							</div>
							<div class="ant-col-8 ant-col-offset-10" style="text-align: right;">
								<div class="" style="display: flex; align-items: center; justify-content: end;">
									<div class="kf-btn-box" @click="openKefu"><button type="button"
											class="ant-btn goodstail-btn kf-btn ant-btn-primary">
											<p style="margin-bottom: 4px; font-size: 13px;">咨询客服</p>
											<p style="font-size: 12px; font-weight: 400; opacity: 0.7;">在线时间10:00-02:00
											</p>
										</button></div><button type="button" @click="addOrder" class="ant-btn goodstail-btn order-btn">
										<p style="font-size: 14px;">立即下单</p>
									</button>
								</div>
								<div class="" style="margin-right: 120px; margin-top: 6px;font-size: 12px;">
									推荐下单前联系客服询问号主是否在线</div>
							</div>
						</div>
					</div>





					<div class="sjz_goods_detail">

						<div class="table_list">
							<el-tabs v-model="activeName">
								<el-tab-pane label="账号详情" name="0">

									<div class="detail-content">
										<div class="" style="margin-bottom: 14px;" v-html="info.archives.content">

										</div>
										<div class="ant-row">
											<div class="">
												<div class="step-title">租号流程</div>
											</div>
											<div class="">
												<img  class="step-img" src="@/assets/image/zuhao.jpg" />
												<!-- <img class="step-img" src="/static/sjz/step-img.png" alt=""> -->
											</div>
										</div>
										<div class="ant-row game_picture_card" v-if="!isMobile">
											<div class="carousel-icon-box left-icon"><i class="icon-carousel"></i></div>
											<div class="carousel-icon-box right-icon"><i class="icon-carousel"></i>
											</div>
											<div class="show_banner" style="margin-top: 20px;">

												<el-carousel height="450px" >
													<el-carousel-item v-for="(item, index) in info.archives.images"
														:key="index">
														<img :src="fixImageUrl(item)"></img>
													</el-carousel-item>
												</el-carousel>
												
											</div>
										</div>
									</div>


								</el-tab-pane>
								<el-tab-pane label="租赁须知" name="1">
									<div class="detail-content">
										<div class="lease_kown_bottom">
											<div class=""><span
													class="mark_styles_number">1</span><span>拉群之后租客和号主优先商量租期，商量完之后租客上号验号，发现号款不对或等级不够请及时指出，上号后20分钟内不指出问题视为验号通过，验号通过后非账号安全问题不退不换。</span>
											</div>
											<div class=""><span
													class="mark_styles_number">2</span><span>号主默认只出纯币，租客如需使用仓库内物资请在群内和号主商量，如租客超规使用物品，则按照总资产消耗进行结算；对于恶意毁号的租客，平台将拉黑并扣除全部押金。</span>
											</div>
											<div class="know_p"><span
													class="mark_styles_number">3</span><span>如因租客开挂导致封号10年，无论是否打完租金都全部归号主所有，平台并额外赔付80%租金作为补偿给到号主（此处订单金额，只指出售纯币对应的订单结算款，皮肤等不在赔付范围内)，一天异地，三天黑屋和七天非开挂类封号是正常的，封号时间不算入租期;30天封禁先申诉，后继如果追封十年补偿。</span>
											</div>
											<div class="know_p"><span
													class="mark_styles_number">4</span><span>上号方式及上号时间由双方协商,在协商时间内，号主超过18小时失联或者累计三次以上无法配合租客上号，租客可申请取消订单，按照消耗金额的80%进行结算，租客超过48小时失联号主可申请强制结算，按照消耗金额的100%进行结算。</span>
											</div>
											<div class=""><span
													class="mark_styles_number">5</span><span>如租期未到一方想要提前结算需征求另一方同意，双方同意后按照实际消耗结算。
												</span></div>
											<div class=""><span
													class="mark_styles_number">6</span><span>群内禁止私聊或私加好友一经发现扣除全额押金和租金，且后续账号安全问题平台概不负责。
												</span></div>
											<div class="know_p"><span
													class="mark_styles_number">7</span><span>如因租客开挂导致封号10年，无论是否打完租金都全部归号主所有，平台并额外赔付80%租金作为补偿给到号主（此处订单金额，只指出售纯币对应的订单结算款，皮肤等不在赔付范围内)，一天异地，三天黑屋和七天非开挂类封号是正常的，封号时间不算入租期;30天封禁先申诉，后继如果追封十年补偿。</span>
											</div>
											<div class=""><span
													class="mark_styles_number">8</span><span>租客改名，结单之前需要报销号主改名卡。 </span>
											</div>
											<div class=""><span
													class="mark_styles_number">9</span><span>号主在租期内禁止上号，上号一次扣除20元结算款。
												</span></div>
											<div class=""><span class="mark_styles_number">10</span><span>一经发现转租押金租金全扣。
												</span></div>
											<div class=""><span
													class="mark_styles_number">11</span><span>双方同意开始租号后视为已阅读过此协议。
												</span></div>
											<div class=""><span
													class="mark_styles_number">12</span><span>此协议最终解释权归于准星三角洲.&nbsp;</span>
											</div>
											<div class=""><span
													class="mark_styles_number">13</span><span>群聊只用来交流租号相关事宜，禁止聊无关事项，禁止号主租客互通价格，结账和售后等问题，联系中介客服。</span>
											</div>
										</div>
									</div>
								</el-tab-pane>

							</el-tabs>
						</div>


					</div>
				</div>

			</div>

		</el-container>
	</div>

</template>
<script>
import {
	Notification,
	Message
} from 'element-ui'
export default {
	data() {
		return {
			goods: {},
			goods_id: 0,
			loading: true,
			info: {},
			daqu: {},
			baopei: {},
			jiaoyi: {},
			kefu: [],
			qun: [],
			type: 0,
			shouxufei: 0,
			activeName: "0",
			kefu_url: "",


		}
	},
	computed: {
		userinfo() {
			return this.$store.getters.userinfo
		},
		gamelist() {
			return this.$store.getters.gamelist
		},
		config() {
			return this.$store.getters.config
		},
		isMobile() {
			return this.$store.getters.isMobile
		},
		login() {
			return this.$store.getters.login
		},
	},
	created: function (data) {

		this.goods_id = this.$route.query.id

		if (this.goods_id == undefined) {
			this.goods_id = this.$route.params.id
		}

		this.getDetail(this.goods_id);
		this.getCollect()

		// https://tb.53kf.com/code/client/10000079/1?u_cust_id=999&u_cust_name=测试&u_custom_info=123456 

	},
	watch: {
		$route() {

		}
	},
	methods: {
		openKefu() {

			api_kefu.push('cmd', 'comeinfo');


			api_kefu.push('title', '编号' + this.goods.id + '-' + this.goods.title);
			api_kefu.push('logo', this.goods.image);
			api_kefu.push('content', '编号' + this.goods.id + '-' + this.goods.title);


			api_kefu.push('curl', 'http://zuhao.kkzh.com/goodsdetail?id=' + this.goods.id);

			api_kefu.query();

			api_kefu.push('cmd', 'kfclient');
			api_kefu.push('type', 'new');
			api_kefu.query();
			// this.$parent.openKefu()




		},
		addOrder() {


			if(!this.login){
				this.$parent.$refs['login'].active = 0
				this.$parent.$refs['login'].visible = true
				return;
			}


				if (this.info.archives.is_sell == 1) {
					this.$message.error("账号锁定中，请稍后再试")
					return
				}
				if (this.info.archives.is_sell == 2) {
					this.$message.error("账号已成交")
					return
				}

				this.$router.push("/addorder?id=" + this.info.archives.id)
			},

		getDetail(id) {
			var that = this;
			this.rq.requests.post("api/game/hall/ArchivesDetail", {
				id: id,
			}).then(res => {
				// ?u_cust_id=999&u_cust_name=测试&u_custom_info=123456 

				if (res.data.archives.images != '' && res.data.archives.images != null) {
					res.data.archives.images = res.data.archives.images.split(',');
				}

				that.info = res.data;
				that.loading = false;
				that.kefu_url = 'https://tb.53kf.com/code/client/dbcf39efd2c649334d9816205b768c0e3/1?u_cust_id=' + user_id + '&u_cust_name=' + nickname + '&u_custom_info=' + this.goods.title

			}).catch(error => {

			})
		},

		shoucang() {
			var that = this;


			var logined = Boolean(localStorage.getItem('usertoken'))

			if (!logined) {
				this.$router.push('/login')
				return;
			}

			this.rq.requests.post("api/game/user/pullCollect", {

				id: that.goods_id,
				type: that.type

			}).then(res => {

				if (that.type == 0) {
					that.type = 1;

					Message.success({
						message: "收藏成功",
						duration: 3000
					})
				} else {
					that.type = 0;
					Message.success({
						message: "已取消",
						duration: 3000
					})
				}

			}).catch(error => {

			})

		},

		getCollect() {
			var that = this;
			this.rq.requests.post("api/game/user/getCollect", {
				id: this.goods_id

			}).then(res => {

				if (res.data.status == 1) {
					that.type = 1;
				}


			}).catch(error => {

			})
		},



	}
}
</script>
<style>
.zuhao .el-radio__input {
	display: flex !important;
	align-items: center;
}

.zuhao .el-radio__input.is-checked .el-radio__inner {
	border-color: #508aff;
	background: #508aff;
}

.zuhao .el-radio__input.is-checked+.el-radio__label {
	color: #508aff;
}
</style>